export interface Article {
  id: string;
  title: string;
  slug: string;
  category: CategorySlug;
  excerpt: string;
  content: string;
  image: string;
  publishDate: string;
  views: number;
  tags: string[];
  isTop: boolean;
  isExclusive: boolean;
}

export type CategorySlug = 'wanghong' | 'yule' | 'redian' | 'shehui' | 'zhibo';

export interface Category {
  slug: CategorySlug;
  name: string;
  description: string;
  count: number;
  image: string;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  content: string;
  avatar: string;
}

export const categories: Category[] = [
  {
    slug: 'wanghong',
    name: '网红黑料',
    description: '网红圈最新爆料，揭秘网红背后的真相',
    count: 1240,
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20ink%20wash%20painting%20style%2C%20melting%20silhouette%20figure%20in%20shadow%2C%20dramatic%20contrast%2C%20Chinese%20contemporary%20art%2C%20minimal%20background%20with%20subtle%20texture%2C%20muted%20olive%20and%20charcoal%20tones%2C%20atmospheric%20mood%2C%20clean%20composition&width=800&height=600&seq=cat-wanghong&orientation=landscape'
  },
  {
    slug: 'yule',
    name: '娱乐圈塌房',
    description: '明星塌房现场追踪，一线爆料不断更新',
    count: 890,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cracked%20ceramic%20texture%20with%20gold%20kintsugi%20repair%20lines%2C%20dramatic%20lighting%20from%20above%2C%20dark%20theatrical%20atmosphere%2C%20sophisticated%20contemporary%20art%20style%2C%20warm%20amber%20accents%20on%20dark%20background%2C%20minimal%20composition%2C%20elegant%20destruction%20aesthetic&width=800&height=600&seq=cat-yule&orientation=landscape'
  },
  {
    slug: 'redian',
    name: '网络热点',
    description: '全网热门事件一手追踪，不错过任何瓜',
    count: 1560,
    image: 'https://readdy.ai/api/search-image?query=Exploding%20abstract%20particles%20and%20fragments%20in%20motion%2C%20dynamic%20energy%20burst%2C%20warm%20coral%20and%20deep%20teal%20color%20palette%2C%20contemporary%20digital%20art%20style%2C%20smooth%20gradient%20background%2C%20minimal%20clean%20aesthetic%2C%20powerful%20visual%20impact&width=800&height=600&seq=cat-redian&orientation=landscape'
  },
  {
    slug: 'shehui',
    name: '社会事件',
    description: '社会热点深度追踪，还原事件真相',
    count: 720,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20layered%20newspaper%20texture%20collage%2C%20overlapping%20translucent%20sheets%2C%20warm%20sepia%20and%20charcoal%20tones%2C%20investigative%20journalism%20aesthetic%2C%20minimal%20composition%20with%20depth%2C%20sophisticated%20editorial%20art%20style%2C%20clean%20background&width=800&height=600&seq=cat-shehui&orientation=landscape'
  },
  {
    slug: 'zhibo',
    name: '直播翻车',
    description: '直播间事故合集，翻车现场全记录',
    count: 530,
    image: 'https://readdy.ai/api/search-image?query=Glitch%20art%20abstract%20digital%20error%20patterns%2C%20fragmented%20screen%20effect%2C%20neon%20pink%20and%20dark%20teal%20contrast%2C%20modern%20digital%20aesthetic%2C%20minimal%20clean%20composition%2C%20smooth%20gradient%20background%2C%20contemporary%20cyber%20art%20style&width=800&height=600&seq=cat-zhibo&orientation=landscape'
  },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某千万粉丝网红深夜直播翻车，不当言论引发全网抵制',
    slug: 'wanghong-zhibo-fanche-2026',
    category: 'wanghong',
    excerpt: '拥有超过1500万粉丝的知名网红在深夜直播中发表不当言论，直播间瞬间涌入超50万人围观，弹幕爆炸。品牌方连夜解约，粉丝数暴跌200万。',
    content: `<p>7月6日凌晨2点，拥有超过1500万粉丝的知名网红"小甜甜"在直播中情绪失控，发表了涉及地域歧视的不当言论，瞬间点燃了网友的愤怒。</p>
<p>据现场录屏显示，当时直播间在线人数从10万迅速攀升至53万，弹幕几乎覆盖了整个屏幕。事件发生后不到两小时，#小甜甜直播翻车# 话题冲上微博热搜榜首，阅读量突破8亿。</p>
<p>截至发稿前，已有三家品牌方宣布与小甜甜解除合作合同，其抖音账号粉丝数从1560万跌至1340万，且仍在持续下跌中。</p>
<p>业内人士分析称，这已经是本年度第七起千万级网红因直播言论翻车的案例，反映出部分头部网红缺乏基本的职业素养和危机意识。</p>
<h3>事件时间线</h3>
<ul>
<li>7月6日 02:00 - 小甜甜开启深夜直播</li>
<li>7月6日 02:47 - 发表争议性言论</li>
<li>7月6日 03:15 - 话题登上微博热搜</li>
<li>7月6日 09:00 - 首个品牌方宣布解约</li>
<li>7月6日 12:00 - 小甜甜发布道歉声明</li>
</ul>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20scene%20of%20a%20single%20figure%20on%20a%20dark%20stage%20with%20harsh%20spotlight%2C%20cracked%20glass%20effect%20overlay%2C%20dark%20olive%20and%20charcoal%20atmosphere%2C%20minimal%20composition%2C%20contemporary%20editorial%20art%20style%2C%20high%20contrast%2C%20moody%20lighting&width=1200&height=800&seq=article-01&orientation=landscape'
    ,
    publishDate: '2026-07-06',
    views: 285000,
    tags: ['直播翻车', '网红', '小甜甜', '地域歧视'],
    isTop: true,
    isExclusive: false,
  },
  {
    id: '2',
    title: '顶流男星被曝已婚生子，工作室紧急辟谣后又秒删',
    slug: 'dingliu-yihun-shengzi-2026',
    category: 'yule',
    excerpt: '某顶流男星被狗仔拍到带娃出行画面，工作室凌晨紧急发布声明称是"亲戚家的孩子"，但随后又删除了该声明。',
    content: `<p>7月5日晚间，知名娱乐狗仔"摄像刘"在其社交平台发布了一组照片，画面中某顶级流量男星怀抱一名约两岁的幼童出现在某高端商场，身边还有一位神秘女子同行。</p>
<p>照片发布后仅30分钟，该男星工作室便发布声明称"孩子是亲戚家的，请大家不要过度解读"。然而，这份声明在发布后不到一小时便被删除，这一反常操作反而引发了更多猜测。</p>
<p>有网友挖出该男星去年曾有长达5个月的空档期，进一步加大了隐婚生子的猜测。截至发稿，该男星本人及其团队均未对此做出进一步回应。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20blurred%20figure%20holding%20a%20small%20child%20in%20a%20luxury%20shopping%20mall%2C%20soft%20focus%20paparazzi%20style%2C%20warm%20amber%20lighting%2C%20dark%20shadows%2C%20mysterious%20atmosphere%2C%20contemporary%20editorial%20photography%2C%20moody%20composition&width=1200&height=800&seq=article-02&orientation=landscape'
    ,
    publishDate: '2026-07-05',
    views: 520000,
    tags: ['娱乐圈', '顶流', '隐婚', '辟谣'],
    isTop: false,
    isExclusive: true,
  },
  {
    id: '3',
    title: '某带货主播涉虚假宣传被罚300万，直播间商品下架近八成',
    slug: 'daihuo-xujia-xuanchuan-2026',
    category: 'redian',
    excerpt: '市场监管部门开出年度最大罚单，某头部带货主播因夸大产品功效被罚款300万元，直播间超80%商品被平台强制下架。',
    content: `<p>7月4日，据市场监管总局官网通报，某拥有2000万粉丝的头部带货主播因长期在直播中对多款保健食品进行虚假宣传和夸大功效，被依法处以300万元行政处罚，并责令其停止违法行为。</p>
<p>通报显示，该主播在2025年10月至2026年5月期间，对18款产品进行了虚假或引人误解的商业宣传。平台方面已对其直播间进行限流处理，超过80%在售商品被下架。</p>
<p>这一事件在带货圈引发强烈震动，多位头部主播连夜自查商品链接，下架了可能存在风险的推广内容。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20scales%20of%20justice%20with%20falling%20shopping%20bags%2C%20dramatic%20red%20and%20dark%20gray%20color%20scheme%2C%20minimal%20composition%2C%20contemporary%20editorial%20art%2C%20clean%20background%2C%20strong%20visual%20metaphor%20for%20consumer%20protection&width=1200&height=800&seq=article-03&orientation=landscape'
    ,
    publishDate: '2026-07-04',
    views: 410000,
    tags: ['直播带货', '虚假宣传', '罚款', '市场监管'],
    isTop: false,
    isExclusive: false,
  },
  {
    id: '4',
    title: '知名游戏主播被爆私下辱骂粉丝，录音曝光后全网声讨',
    slug: 'youxi-zhubo-ruma-fensi-2026',
    category: 'zhibo',
    excerpt: '一段长达8分钟的录音在网络疯传，某电竞圈知名主播在私下通话中大肆辱骂为其氪金的粉丝，称其"傻有钱"。',
    content: `<p>7月3日晚，一段8分钟的通话录音在网络上迅速传播。录音中，某拥有800万粉丝的电竞主播在与朋友私下通话时，大肆嘲讽并辱骂那些为其直播间大量消费的粉丝。</p>
<p>录音中该主播称粉丝为"傻有钱""人傻钱多速来"，并详细讲述了自己如何通过虚假人设维持"宠粉"形象。录音曝光后，该主播的直播间被愤怒的粉丝刷屏，"退钱"弹幕持续了整整6个小时。</p>
<p>该主播随后发布道歉视频，但大部分网友并不买账，认为其道歉缺乏诚意。其直播间礼物收入在事件后暴跌95%。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20shattered%20headphones%20with%20sound%20waves%20disintegrating%2C%20dark%20teal%20and%20coral%20color%20contrast%2C%20minimal%20clean%20composition%2C%20contemporary%20digital%20art%2C%20dramatic%20lighting%2C%20emotional%20atmosphere&width=1200&height=800&seq=article-04&orientation=landscape'
    ,
    publishDate: '2026-07-03',
    views: 380000,
    tags: ['游戏主播', '录音曝光', '辱骂粉丝', '人设崩塌'],
    isTop: false,
    isExclusive: false,
  },
  {
    id: '5',
    title: '某女星婚礼现场被爆与前男友藕断丝连，新郎当场黑脸',
    slug: 'nvxing-hunli-qiannanyou-2026',
    category: 'yule',
    excerpt: '圈内某知名女星7月2日婚礼现场，一位不速之客的出现让整个现场气氛降到冰点，新郎全程黑脸引发热议。',
    content: `<p>7月2日，圈内某知名女星在某海岛举办盛大婚礼。然而，婚礼现场出现的一位"不速之客"——该女星的前男友、同样是知名演员的某某某，让整场婚礼的气氛变得异常尴尬。</p>
<p>据现场宾客透露，这位前男友并非被邀请参加婚礼，而是恰好入住同一酒店。他在婚礼仪式进行到一半时不慎出现在现场附近，新郎发现后全程黑脸，众多宾客也面露尴尬。</p>
<p>网友对此反应两极：有人认为只是巧合不该过度解读，也有人调侃这是"本年度最修罗场的婚礼现场"。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20wedding%20scene%20with%20dramatic%20split%20lighting%2C%20one%20side%20warm%20and%20bright%2C%20other%20side%20cold%20and%20dark%2C%20tension%20atmosphere%2C%20minimal%20composition%2C%20contemporary%20editorial%20art%2C%20subtle%20olive%20and%20coral%20tones&width=1200&height=800&seq=article-05&orientation=landscape'
    ,
    publishDate: '2026-07-02',
    views: 650000,
    tags: ['娱乐圈', '婚礼', '前男友', '修罗场'],
    isTop: false,
    isExclusive: true,
  },
  {
    id: '6',
    title: '网红餐饮店被曝使用过期食材，后厨监控画面触目惊心',
    slug: 'wanghong-canyin-guoqi-shicai-2026',
    category: 'shehui',
    excerpt: '某短视频平台爆火的网红餐饮品牌被内部员工曝光使用过期食材，后厨卫生状况堪忧，相关门店已被市场监管部门查封。',
    content: `<p>7月1日，一位自称是某网红连锁餐饮品牌前员工的网友，在社交平台发布了一段后厨监控视频，显示该品牌多家门店存在使用过期食材、回收剩菜等问题。</p>
<p>视频中可以看到，已发霉的蔬菜被简单处理后继续使用，超过保质期数月的调料仍在正常供应给顾客。视频发布后，市场监管部门迅速介入调查，涉事的三家门店已被依法查封。</p>
<p>该品牌在事件后发表声明称是"个别门店管理不善"，但网友们并不买账，纷纷表示"再也不去吃了"。该品牌在全国拥有超过200家门店，此次事件对其造成了不可估量的品牌损失。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20kitchen%20with%20shadowy%20figures%2C%20deteriorating%20food%20textures%2C%20dramatic%20contrast%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20dark%20olive%20and%20rust%20tones%2C%20minimal%20composition%2C%20disturbing%20atmosphere&width=1200&height=800&seq=article-06&orientation=landscape'
    ,
    publishDate: '2026-07-01',
    views: 890000,
    tags: ['食品安全', '网红餐饮', '过期食材', '查封'],
    isTop: false,
    isExclusive: false,
  },
  {
    id: '7',
    title: '某知识付费大V被爆学历造假，北大回应查无此人',
    slug: 'zhishi-fufei-xueli-zaojia-2026',
    category: 'redian',
    excerpt: '拥有50万付费用户的某知识付费大V自称北大硕士却被网友扒出学历造假，北大官方回应：查无此人。',
    content: `<p>6月30日，有网友在北大校友数据库中查询发现，自称"北京大学经济学硕士"的某知名知识付费大V的学历信息疑似造假。该大V的付费社群拥有超过50万成员，年收入据估算超过5000万元。</p>
<p>事件发酵后，北京大学官方发表简短声明称："经核实，我校学籍系统中查无此人相关信息。"这一回应几乎坐实了学历造假的指控。</p>
<p>该大V随后发布长文道歉，承认自己确实未取得北大硕士学位，但辩称自己"曾以旁听生身份在北大学习"。此解释被网友群嘲为"年度最佳甩锅文案"。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20shattered%20diploma%20with%20pieces%20falling%2C%20dark%20academic%20atmosphere%2C%20deep%20olive%20and%20gold%20tones%2C%20minimal%20clean%20composition%2C%20contemporary%20editorial%20art%2C%20dramatic%20lighting%2C%20intellectual%20deception%20theme&width=1200&height=800&seq=article-07&orientation=landscape'
    ,
    publishDate: '2026-06-30',
    views: 730000,
    tags: ['学历造假', '知识付费', '北大', '人设崩塌'],
    isTop: false,
    isExclusive: false,
  },
  {
    id: '8',
    title: '短视频平台两大顶流互撕，聊天记录曝光揭惊人内幕',
    slug: 'duanshipin-husi-jilu-baoguang-2026',
    category: 'wanghong',
    excerpt: '两大千万级短视频博主突然在社交平台相互攻击，随后一份私下聊天记录被曝光，揭开了两人不为人知的合作内幕。',
    content: `<p>6月28日，短视频平台两大头部博主"阿泽"和"小鹿"突然在微博上隔空互撕，互相指责对方抄袭内容和挖墙脚。</p>
<p>令人意外的是，当天晚上一份据称是两人去年的私下聊天记录被曝光，显示两人曾秘密商议联手炒作、互相制造话题以获取流量。这份记录的曝光让两人的互撕看起来更像是一场精心策划的戏码。</p>
<p>网友们纷纷感叹："原来我们才是被割的韭菜"，"吃瓜吃到自己头上"。两方粉丝也陷入混乱，部分粉丝选择脱粉。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20two%20opposing%20forces%20colliding%20with%20dramatic%20energy%2C%20split%20color%20scheme%20warm%20coral%20versus%20cool%20teal%2C%20digital%20glitch%20effect%2C%20minimal%20composition%2C%20contemporary%20art%20style%2C%20intense%20visual%20impact&width=1200&height=800&seq=article-08&orientation=landscape'
    ,
    publishDate: '2026-06-28',
    views: 940000,
    tags: ['互撕', '聊天记录', '炒作', '短视频'],
    isTop: false,
    isExclusive: true,
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: '匿名投稿人A',
    role: '资深爆料人',
    content: '五一吃瓜网是我见过更新最快的爆料平台。作为一个深耕娱乐圈八年的幕后工作者，我选择在这里独家发布我的一手消息，因为这里的读者最懂行，编辑也最尊重爆料人的隐私。',
    avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20abstract%20portrait%2C%20faceless%20silhouette%20in%20shadow%2C%20warm%20amber%20lighting%20from%20side%2C%20minimal%20dark%20background%2C%20contemporary%20art%20style%2C%20anonymous%20whistleblower%20aesthetic&width=300&height=300&seq=testimonial-01&orientation=squarish'
  },
  {
    id: 't2',
    name: '吃瓜群众小美',
    role: '忠实读者',
    content: '每天早晨第一件事就是打开五一吃瓜网看看有什么新瓜。从去年开始关注，已经把这个网站推荐给了身边所有爱八卦的朋友。内容质量高，更新快，基本我关注的网红翻车这里都是首发！',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20portrait%20silhouette%2C%20soft%20coral%20and%20amber%20lighting%2C%20friendly%20vibe%2C%20minimal%20composition%2C%20contemporary%20editorial%20style%2C%20clean%20background&width=300&height=300&seq=testimonial-02&orientation=squarish'
  },
  {
    id: 't3',
    name: '媒体人老张',
    role: '行业观察者',
    content: '作为一个做了十五年娱乐新闻的老媒体人，我不得不说五一吃瓜网在很多热点事件的报道速度和准确度上，已经超越了很多传统媒体。希望继续保持这种专业精神。',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20mature%20professional%20portrait%20silhouette%2C%20warm%20olive%20and%20charcoal%20tones%2C%20serious%20journalistic%20vibe%2C%20minimal%20composition%2C%20contemporary%20art%20style%2C%20clean%20dark%20background&width=300&height=300&seq=testimonial-03&orientation=squarish'
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};

export const getArticlesByCategory = (slug: string): Article[] => {
  return articles.filter((a) => a.category === slug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getRelatedArticles = (article: Article, limit: number = 4): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, limit);
};

export const getLatestArticles = (limit: number = 8): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
};

export const getTopArticle = (): Article | undefined => {
  return articles.find((a) => a.isTop) || articles[0];
};